module.exports = __webpack_public_path__ + "static/img/lange_crub_4.5b7b7904.jpg";